/**
 * Products / category page hero (converted from products.html and
 * detail_category.html). A title plus an eight-column intro paragraph.
 *
 * The two source pages differ slightly: the products page renders the title as
 * an <h1 className='bold-text'>; the category page wraps the whole hero in an
 * extra `.animation-on-load-01` and renders the title as an
 * <h2 className='bold-text caps'>. `variant` selects between them. The
 * page-load reveal (a-16, `.animation-on-load-0N`) is handled globally in
 * SiteAnimations.
 */
import type { FC } from 'react'

interface ProductsHeroProps {
    title: string
    description: string
    contentId: string
    variant?: 'products' | 'category'
}

export const ProductsHero: FC<ProductsHeroProps> = ({
    title,
    description,
    contentId,
    variant = 'products'
}) => {
    const hero = (
        <div className='products-hero-container'>
            <div className='animation-on-load-01'>
                {variant === 'category' ? (
                    <h2 className='bold-text caps'>{title}</h2>
                ) : (
                    <h1 className='bold-text'>{title}</h1>
                )}
            </div>
            <div className='animation-on-load-02'>
                <div className='grid-8-col'>
                    <div id={contentId} className='content'>
                        <p>{description}</p>
                    </div>
                </div>
            </div>
        </div>
    )

    if (variant === 'category') {
        return <div className='animation-on-load-01'>{hero}</div>
    }

    return hero
}
